import * as React from 'react';
import { Dialog, AppBar, DialogActions, Button, WithStyles, createStyles, Theme, withStyles, DialogContent, Typography, Toolbar, FormControl, InputLabel, InputBase, Grid } from '@material-ui/core';
import { DeltaXMLColors } from './styling/DeltaColors';
import { ProfileDetails } from './ProfileContent';
import { SaaSTrialStatus } from './SaaSContent';
import { Utilities } from '../general/utilities';

const BootstrapInput = withStyles((theme: Theme) =>
  createStyles({
    root: {
      'label + &': {
        marginTop: theme.spacing(3),
      },
    },
    input: {
      borderRadius: 4,
      position: 'relative',
      backgroundColor: theme.palette.background.paper,
      border: '1px solid ' + DeltaXMLColors.OXFORD_BLUE,
      fontSize: 16,
      padding: '10px',
      width: '240px',
      '&:focus': {
        // Set border color
        border: '1px solid ' + DeltaXMLColors.CELERY
      }
    },
    error: {
      borderRadius: 4,
      position: 'relative',
      backgroundColor: theme.palette.background.paper,
      border: '1px solid ' + DeltaXMLColors.VALENTINE_RED,
      fontSize: 16,
      width: '262px'
    },
  }),
)(InputBase);

const styles = (theme: Theme) =>
  createStyles({
    margin: {
      margin: theme.spacing(2),
    },
    inputLabel: {
      fontSize: '17',
      width: '150px',
      color: DeltaXMLColors.GRAY
    },
    profileLabels: {
      margin: '24px 0px 0px 0px',
      height: '41px',
      width: '240px',
      fontWeight: 500,
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      color: DeltaXMLColors.OXFORD_BLUE
    }
  });

export interface SaaSCCConfirmTrialProps extends WithStyles<typeof styles> {
  open: boolean,
  profileDetails: ProfileDetails,
  handleConfirmTrialDialogOpen: (open: boolean) => void,
  startSubsTrial: (trialData: SubsTrialData) => void
}

enum TrialFieldLabel {
  firstName = 'First Name',
  lastName = 'Last Name',
  compName = 'Company Name'
}

export interface SubsTrialData {
  firstName: string,
  lastName: string,
  compName: string
}


function SaaSConfirmTrial(props: SaaSCCConfirmTrialProps) {
  const { classes, open, profileDetails, handleConfirmTrialDialogOpen, startSubsTrial } = props;
  const [firstName, setFirstName] = React.useState(profileDetails.givenName);
  const [lastName, setLastName] = React.useState(profileDetails.familyName);
  const [companyName, setCompanyName] = React.useState(profileDetails.compName);


  const handleTrialConfirm = () => {
    handleConfirmTrialDialogOpen(false);
    startSubsTrial({
      firstName: firstName.trim(),
      lastName: lastName.trim(),
      compName: companyName.trim()
    });
  }

  const handleChange = (event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
    const fieldValue = event.target.value as string;
    switch (event.target.name) {
      case TrialFieldLabel.firstName:
        setFirstName(fieldValue);
        break;
      case TrialFieldLabel.lastName:
        setLastName(fieldValue);
        break;
      case TrialFieldLabel.compName:
        setCompanyName(fieldValue);
        break;
    }
  }

  const allTextFieldsValid = Utilities.validateNonEmptyText(firstName) && Utilities.validateNonEmptyText(lastName) && Utilities.validateNonEmptyText(companyName);

  return (
    <Dialog open={open} onClose={() => handleConfirmTrialDialogOpen(false)}>
      <AppBar position="static">
        <Toolbar>
          <Typography variant="h4">Confirm Trial</Typography>
        </Toolbar>
      </AppBar>
      <DialogContent>
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <FormControl className={classes.margin}>
                <InputLabel className={classes.inputLabel} shrink={true}>{TrialFieldLabel.firstName}</InputLabel>
                <BootstrapInput name={TrialFieldLabel.firstName} value={firstName} onChange={handleChange} error={!Utilities.validateNonEmptyText(firstName)} />
              </FormControl>
              <FormControl className={classes.margin}>
                <InputLabel className={classes.inputLabel} shrink={true}>{TrialFieldLabel.lastName}</InputLabel>
                <BootstrapInput name={TrialFieldLabel.lastName} value={lastName} onChange={handleChange} error={!Utilities.validateNonEmptyText(lastName)} />
              </FormControl>
              <FormControl className={classes.margin}>
                <InputLabel className={classes.inputLabel} shrink={true}>{TrialFieldLabel.compName}</InputLabel>
                <BootstrapInput name={TrialFieldLabel.compName} value={companyName} onChange={handleChange} error={!Utilities.validateNonEmptyText(companyName)} />
              </FormControl>
            </Grid>
            <Grid item xs={6}>
              <FormControl className={classes.margin}>
                <InputLabel className={classes.inputLabel} shrink={true}>Email Address</InputLabel>
                <Typography className={classes.profileLabels}>{profileDetails.emailAddress}</Typography>
              </FormControl>
            </Grid>
          </Grid>
      </DialogContent>
      <DialogActions>
        <Button variant="contained" color="primary" onClick={handleTrialConfirm} disabled={!allTextFieldsValid}>
          Confirm
        </Button>
        <Button variant="contained" color="primary" onClick={() => handleConfirmTrialDialogOpen(false)}>
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  )
};

export default withStyles(styles)(SaaSConfirmTrial);